import DashboardTeamConnectionPoints from './DashboardTeamConnectionPoints';
export default DashboardTeamConnectionPoints;
